module.exports = "/_next/static/resources/life1-b8142902c6409e78928c55d07363a4f3.webp";